export function Index(): string {
	return `/v1/config`;
}

